import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";
import { useAppStore } from "@/pinia/app";
import { SubscriptionModule } from "@/types";

interface Props {
  moduleIds: number[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSubModuleCards',
  props: {
    moduleIds: null
  },
  setup(__props: any) {

const props = __props as {
  moduleIds: number[];
};


const { moduleIds } = toRefs(props);

const appStore = useAppStore();

const modules = computed(() => {
  const list: SubscriptionModule[] = [];

  moduleIds.value.forEach((id) => {
    const module = appStore.lookupTables.subscriptionModules.find(
      (m) => id === m.id
    );
    if (module) {
      list.push(module);
    }
  });

  return list.sort((a, b) => a.id - b.id);
});

return { __sfc: true,props, moduleIds, appStore, modules }
}

})